// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1Uah7","footer":"ModalUpdate_footer__14xFc"};